import { render, staticRenderFns } from "./kPagination.vue?vue&type=template&id=63c9d9d3&scoped=true"
import script from "./kPagination.vue?vue&type=script&lang=js"
export * from "./kPagination.vue?vue&type=script&lang=js"
import style0 from "./kPagination.vue?vue&type=style&index=0&id=63c9d9d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c9d9d3",
  null
  
)

export default component.exports